import { ROUTE_DATA_SETS, ROUTE_DATA_SOURCES, ROUTE_DESTINATIONS } from './pathnames';
import { SearchFilterViews } from './visibilityFilters';

export const RESOURCE_TYPE_SOURCE = 'data_sources';
export const RESOURCE_TYPE_SINK = 'data_sinks';
export const RESOURCE_TYPE_DATA_SET = 'data_sets';
export const RESOURCE_TYPE_DATA_MAP = 'data_maps';
export const RESOURCE_TYPE_ATTR_TRANSFORM = 'code_containers';
export const RESOURCE_TYPE_RECORD_TRANSFORM = 'code_containers';
export const RESOURCE_TYPE_SCHEMA_SPECS = 'data_schemas';
export const RESOURCE_TYPE_USER = 'users';
export const RESOURCE_TYPE_FLOW = 'flows';
export const RESOURCE_TYPE_PROJECTS = 'projects';
export const RESOURCE_TYPE_CREDENTIALS = 'credentials';
export const RESOURCE_TYPE_CREDENTIAL_GROUP = 'credential_group';
export const RESOURCE_TYPE_MARKETPLACE_ITEM = 'marketplace_item';
export const RESOURCE_TYPE_MARKETPLACE_DOMAINS = 'marketplace_domains';

export const getEndpointResourcePath = (resourceType) => {
  const paths = {
    [RESOURCE_TYPE_CREDENTIALS]: 'data_credentials',
  };
  return paths[resourceType] || resourceType;
};

export const NOTIFICATION_EVENT_TYPE_MONITOR = 'MONITOR';

export const METRICS_RESOURCE_NAME_SOURCE = 'SOURCE';
export const METRICS_RESOURCE_NAME_SINK = 'SINK';
export const METRICS_RESOURCE_NAME_SET = 'DATASET';

export const METRICS_RESOURCE_TYPE_MAPPING = {
  sources: RESOURCE_TYPE_SOURCE,
  sinks: RESOURCE_TYPE_SINK,
  datasets: RESOURCE_TYPE_DATA_SET,
};

export const LINEAGE_RESOUCE_TYPES = {
  data_source: 'data_source',
  data_set: 'data_set',
  data_sink: 'data_sink',
};

export const CONNECTORS_RESOURCE_TYPES = {
  SOURCE: 'SOURCE',
  DESTINATION: 'DESTINATION',
  QUARANTINE: 'QUARANTINE',
};

export const API_KEY_RESOURCE_TYPES = {
  [RESOURCE_TYPE_SOURCE]: {
    key: RESOURCE_TYPE_SOURCE,
    displayName: 'Source',
    route: ROUTE_DATA_SOURCES,
    filterView: SearchFilterViews.SOURCES,
  },
  [RESOURCE_TYPE_SINK]: {
    key: RESOURCE_TYPE_SINK,
    displayName: 'Destination',
    route: ROUTE_DESTINATIONS,
    filterView: SearchFilterViews.DATA_SINKS,
  },
  [RESOURCE_TYPE_DATA_SET]: {
    key: RESOURCE_TYPE_DATA_SET,
    displayName: 'Dataset',
    route: ROUTE_DATA_SETS,
    filterView: SearchFilterViews.MY_DATA_SETS,
  },
  [RESOURCE_TYPE_USER]: {
    key: RESOURCE_TYPE_USER,
    displayName: 'User',
    route: null,
    filterView: null,
  },
};

export const RESOURCE_NAME_BY_TYPE = {
  [RESOURCE_TYPE_SOURCE]: 'Source',
  [RESOURCE_TYPE_DATA_SET]: 'Nexset',
  [RESOURCE_TYPE_SINK]: 'Destination',
};
